import 'react-native-get-random-values';
import 'react-native-gesture-handler';
import {LogBox, Platform} from 'react-native';
import {registerRootComponent} from 'expo';
import {activateKeepAwakeAsync} from 'expo-keep-awake';
import {setProxy} from '@lookiero/data-sources';
import {configurePromoCodes} from '@modules/promoCodes/config';
import {getProxy} from './config/proxy';
import {replaceConfigUrlsWithTopLevelDomain} from './src/ui/helpers/replaceConfigUrlsWithTopLevelDomain';
import {configurePayments} from './src/modules/payments/config/configurePayments';
import {App} from './src/ui/app/App';

// eslint-disable-next-line no-undef
if (__DEV__ && Platform.OS === 'web' && typeof navigator !== 'undefined' && 'wakeLock' in navigator) {
  void activateKeepAwakeAsync();
}

if (Platform.OS !== 'web') {
  LogBox.ignoreAllLogs(true);
  setProxy(getProxy());
  replaceConfigUrlsWithTopLevelDomain();
}

configurePayments();
configurePromoCodes();

registerRootComponent(App);
